// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1riU9","checkboxCol":"Table_checkboxCol__lhWy6","emailCol":"Table_emailCol__2A9LG","actionCol":"Table_actionCol__yVB6E"};